import { FC, InputHTMLAttributes, PropsWithChildren, useRef } from "react";
import { useToggleState } from "@react-stately/toggle";
import { useCheckbox, useFocusRing } from "react-aria";
import { AriaCheckboxProps } from "@react-types/checkbox";
import { Label, StyledCheckbox } from "./Checkbox.styled";
import classNames from "classnames";

const Checkbox: FC<
  PropsWithChildren<
    InputHTMLAttributes<HTMLInputElement> &
      AriaCheckboxProps & { alignInput?: "start" | "center" }
  >
> = ({ onTransitionEnd, ...props }) => {
  const { alignInput, children, disabled, checked } = props;
  const state = useToggleState({ ...props, isSelected: checked });
  const ref = useRef(null);
  const { inputProps } = useCheckbox(
    {
      ...props,
      isDisabled: disabled,
      isSelected: checked,
      "aria-label": `Select ${props.value || ""}`,
    },
    state,
    ref
  );
  const { isFocusVisible, focusProps } = useFocusRing();

  return (
    <StyledCheckbox
      className={classNames({ ["disabled"]: inputProps.disabled })}
      data-testid="styled-checkbox"
    >
      <input
        {...inputProps}
        {...focusProps}
        ref={ref}
        data-testid="checkbox"
        type="checkbox"
        onTransitionEnd={onTransitionEnd || undefined}
        className={classNames({
          ["focus-visible"]: isFocusVisible,
          ["align-start"]: alignInput === "start",
          ["align-center"]: alignInput === "center",
          ["disabled"]: inputProps.disabled,
        })}
      />
      <Label as="span" data-testid="label">
        {children}
      </Label>
    </StyledCheckbox>
  );
};

export default Checkbox;
